import React from 'react';
import { GeoJSON } from 'react-leaflet';

const NeighborhoodLayer = ({ neighborhoods, activeFilter, setSelectedNeighborhood }) => {
	

  const getSafetyColor = (score) => {
    if (score >= 8) return '#4caf50';
    if (score >= 6) return '#ff9800';
    if (score >= 4) return '#f44336';
    if (score > 0) return '#8B0000';
    return '#ccc';
  };
  
  const getAvailabilityColor = (score) => {
    if (score >= 4) return '#08519c';
    if (score >= 3) return '#3182bd';
    if (score >= 1) return '#6baed6';
    return '#777';
  };
  
  const getRentalCostColor = (score) => {
    if (score >= 4000) return '#800026';
    if (score >= 3000) return '#bd0026';
    if (score >= 2000) return '#e31a1c';
    if (score >= 1000) return '#fc4e2a';
    if (score > 0) return '#fd8d3c';
    return '#000000'; // no data or 0
  };


  const style = (feature) => ({
    color: '#2c2c2c',
    weight: 1.5,
    fillOpacity: 0.7,
    fillColor: activeFilter === 'safety'
      ? getSafetyColor(feature.properties.characteristics.Saftey)
	  : activeFilter === 'rentalAvailability'
      ? getAvailabilityColor(feature.properties.characteristics.availability)
	  : activeFilter === 'rentalCost'
      ? getRentalCostColor(feature.properties.characteristics.rentalCost)
      : '#4da3ff',
  });

  const onEachFeature = (feature, layer) => {
    let label = feature.properties.neighborhoodName;

    if (activeFilter === 'safety') {
      const score = feature.properties.characteristics.Saftey;
      label += score ? `: Safety ${score}/10` : ': No Safety Data';
    } else if (activeFilter === 'rentalAvailability') {
      const score = feature.properties.characteristics.availability;
      label += `: ${score} units available`;
    } else if (activeFilter === 'rentalCost') {
      const score = feature.properties.characteristics.rentalCost;
      label += score ? `: Avg. Rent $${Math.round(score)}` : ': No Rental Data';
    }
	
    layer.bindTooltip(label, {
      permanent: false,
      direction: 'center',
      className: 'neighborhood-label'
    });

    layer.on({
      mouseover: () => setSelectedNeighborhood(feature),
      mouseout: () => setSelectedNeighborhood(null),
      click: () => layer._map.fitBounds(layer.getBounds())
    });
  };

  return <GeoJSON data={neighborhoods} style={style} onEachFeature={onEachFeature} />;
};

export default NeighborhoodLayer;
